import { theme } from 'antd'
import dayjs from 'dayjs'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useMemo } from 'react'

type TopPost = {
    date: string
    reactions: number
    views: number
    telegramId: number
    telegramUrl: string
}

export const HorizontalBar = ({
    topPosts = [],
    title = 'Топ-посты по охвату',
    height = 400
}: {
    topPosts?: TopPost[]
    title?: string
    height?: number
}) => {
    const {
        token: { colorBgElevated, colorText }
    } = theme.useToken()

    const categories = topPosts.map(
        (post) =>
            `<a href="${post.telegramUrl}" target="_blank" style="color:#7c9bad;text-decoration:none;">
                Пост: ${dayjs(post.date).format('DD:MM')}
            </a>`
    )

    const data = topPosts.map((post) => ({
        y: post.views,
        reactions: post.reactions,
        date: new Date(post.date).toLocaleDateString('ru-RU')
    }))

    const options = useMemo(() => {
        return {
            chart: {
                type: 'bar',
                backgroundColor: colorBgElevated,
                height,
                borderRadius: 10
            },
            credits: { enabled: false },
            title: { text: title, style: { color: colorText } },
            xAxis: {
                categories,
                labels: {
                    useHTML: true,
                    style: { color: colorText }
                }
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Всего просмотров',
                    style: { color: colorText }
                },
                labels: {
                    overflow: 'justify',
                    style: { color: colorText }
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: { enabled: true, style: { color: colorText } }
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                formatter: function () {
                    return `
                        <b>${categories[this.point.index]}</b><br/>
                        Дата: ${this.point.date}<br/>
                        Просмотры: ${this.y}<br/>
                        Реакции: ${this.point.reactions}
                    `
                }
            },
            series: [
                {
                    name: 'Просмотры',
                    data
                }
            ]
        }
    }, [categories, data, title, height, colorBgElevated, colorText])

    return (
        <div className="w-full">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    )
}
